module.exports = __webpack_public_path__ + "static/media/senal-memoria.c170d0dc.svg";